module.exports = {
  API_URL: process.env.REACT_APP_API_URL,
  PORT: process.env.PORT,
  IMG_URL: process.env.REACT_APP_IMG_URL,
  JOB_DETAILS: process.env.REACT_APP_JOB_DETAILS,
};
